<script setup lang="ts">
  import { type Workspace } from '@bv/api/user';
  import { useUserStore } from '@bv/stores/user';
  import { VueQueryDevtools } from '@tanstack/vue-query-devtools';
  import { ref, watch, computed } from 'vue';

  import { useSystemStore } from './stores/general/system.store';

  const userStore = useUserStore();
  const systemStore = useSystemStore();

  const isInitiated = ref(false);
  const currentWorkspace = computed<Workspace | undefined>(() => userStore.currentWorkspace);

  const reloadPage = (): void => {
    window.location.reload();
  };

  watch(
    currentWorkspace,
    (workspace) => {
      if (isInitiated.value) {
        reloadPage();
      }

      if (workspace?.id) {
        isInitiated.value = true;
      }
    },
    { deep: true },
  );

  const theme = window?.localStorage?.getItem('currentTheme') || 'light';
  systemStore.setCurrentTheme(theme);
</script>

<template>
  <bv-view />
  <vue-query-devtools />
</template>
